import { Fuel, VehicleModelWithInsurancesForD2CDto } from '@orcar/common';
import {
  convertToKST,
  filterOptionAtom,
  PAGE_NAME,
  SearchResultBlock,
  SESSION_STORAGE_KEY,
  useRecoil,
} from '@orcar/common-d2c';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SearchResultProps } from '../../components/SearchResult';
import { TopButton } from '../../components/TopButton';
import SearchFilterNull from '../../components/vehicleCard/SearchFilterNull';

interface MobileSearchResultProps extends SearchResultProps {
  filterResult?: VehicleModelWithInsurancesForD2CDto[];
  resultCount: number | undefined;
}

const MobileSearchResult = ({
  filterResult,
  resultCount,
  searchOptions,
}: MobileSearchResultProps) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    recoilState: [recoilFilterOption, setRecoilFilterOption],
  } = useRecoil(filterOptionAtom);

  const [fadeInTrigger, setFadeInTrigger] = useState(false);

  useEffect(() => {
    const carType = searchParams.get('carType');
    const carFuel = searchParams.get('carFuel');

    const newFilterOption = { ...recoilFilterOption };

    // Reset both lists first
    newFilterOption.carTypeList = [];
    newFilterOption.carFuelList = [];

    // Set each parameter independently
    if (carType) {
      newFilterOption.carTypeList = [carType];
    }

    if (carFuel === Fuel.EV) {
      newFilterOption.carFuelList = [Fuel.EV];
    }

    setRecoilFilterOption(newFilterOption);
  }, [searchParams, setRecoilFilterOption]);

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);

    // Handle carType
    if (recoilFilterOption.carTypeList.length === 1) {
      const carType = recoilFilterOption.carTypeList[0];
      newSearchParams.set('carType', carType);
      newSearchParams.delete('carFuel');
    } else {
      newSearchParams.delete('carType');
      // Handle carFuel
      if (
        recoilFilterOption.carFuelList.length === 1 &&
        recoilFilterOption.carFuelList.includes(Fuel.EV)
      ) {
        newSearchParams.set('carFuel', Fuel.EV);
      } else {
        newSearchParams.delete('carFuel');
      }
    }

    setSearchParams(newSearchParams, { replace: true });
  }, [
    recoilFilterOption.carTypeList,
    recoilFilterOption.carFuelList,
    searchParams,
    setSearchParams,
  ]);

  const handleSelectProducts = async (id: number, insuranceName: string) => {
    sessionStorage.setItem(SESSION_STORAGE_KEY.PRODUCT_ID, String(id));

    const pickUpAt = convertToKST(searchOptions.pickUpAt);
    const dropOffAt = convertToKST(searchOptions.dropOffAt);

    navigate({
      pathname: PAGE_NAME.order_confirmation,
      search: `?pickUpAt=${pickUpAt}&dropOffAt=${dropOffAt}&insuranceName=${insuranceName}`,
    });
  };

  useEffect(() => {
    setFadeInTrigger(true);
    setTimeout(() => {
      setFadeInTrigger(false);
    }, 100);
  }, [recoilFilterOption]);

  return (
    <div className='flex h-full flex-col gap-3'>
      {resultCount === 0 ? (
        <SearchFilterNull />
      ) : (
        filterResult?.map((vehicleModel) => (
          <SearchResultBlock
            platform='mobile'
            key={vehicleModel.id}
            vehicleModel={vehicleModel}
            unavailable={vehicleModel.availableCount === 0}
            customSuperInsuranceName='고급자차 + 무제한특약'
            handleClickCard={handleSelectProducts}
            fadeInTrigger={fadeInTrigger}
            hideNoneInsurance
          />
        ))
      )}
      {resultCount !== 0 && <TopButton />}
    </div>
  );
};

export default MobileSearchResult;
